import { getBase64 } from "./imageChecker";

export default {
    readRecruiterPhoto(recruiter = {}, customRecruiterPhoto = 'img/avatar.png') {
        recruiter['recruiter_photo'] = getBase64(recruiter.recruiter_photo, true, customRecruiterPhoto);
        return recruiter;
    }
}